export default function PageHeader({ eyebrow, title, desc }) {
  return (
    <div className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-16 pt-16 sm:pt-24 pb-10" data-testid="page-header">
      {eyebrow && <div className="eyebrow mb-4">{eyebrow}</div>}
      <div className="gold-line mb-6" />
      <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight leading-[1.05]">{title}</h1>
      {desc && <p className="mt-5 text-[#8C7E83] max-w-xl text-base sm:text-lg leading-relaxed">{desc}</p>}
    </div>
  );
}
